import { create } from "zustand";
import { User } from "../types/models";
import { UserAccountDto, UserDto } from "../types/dto";

type UserStore = {
  user: UserAccountDto | null;
  setUser: (user: UserAccountDto | null) => void;
};

export const useUserStore = create<UserStore>((set) => ({
  user: null,
  setUser: (user) => set({ user }),
}));

type Store = {
  branchName: string;
  branchCode: string;
  brandId: number;
  setBranchName: (name: string) => void;
  setBranchCode: (code: string) => void;
  setBrandId: (id: number) => void;
};

export const useBranchStore = create<Store>((set) => ({
  branchName: "",
  branchCode: "",
  brandId: 0,
  setBranchName: (name) => set((state) => ({ ...state, branchName: name })),
  setBranchCode: (code) => set((state) => ({ ...state, branchCode: code })),
  setBrandId: (id) => set((state) => ({ ...state, brandId: id })),
}));

interface State {
  isMuted: boolean;
  toggleMute: () => void;
}

export const useMuteStore = create<State>((set) => ({
  isMuted: false,
  toggleMute: () => set((state) => ({ isMuted: !state.isMuted })),
}));
